<template>
  <div class="--card">
    <div class="header">
      <slot name="header"></slot>
    </div>
    <div class="body">
      <slot name="body"></slot>
    </div>
    <div class="footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<style scoped >
.--card {
  border-radius: 10px;
  overflow: hidden;
  isolation: revert;
  background-color: #fff;
  .header,
  .body,
  .footer {
    padding: 10px 25px
  }
  .header {
    background-color: #FCFCFC;
    /*border-bottom: 1px solid #ccc;*/
  }
  .body {
  }
}
</style>